var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg005User(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6C37;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263,472H61.7c-8.5,0-13.7-4.8-16-7.6c-4-4.9-5.5-11.3-4.2-17.5c20.8-99.8,108.8-172.6,210.5-175 c1.7,0.1,3.4,0.1,5.1,0.1c75,0,136-61,136-136S332,0,257,0c-75,0-136,61-136,136c0,44.5,21.5,84.1,54.6,108.9 c-30.4,10-58.9,25.5-83.8,46.1c-45.7,37.6-77.5,90.1-89.5,147.7c-3.8,18.1,0.7,36.6,12.4,50.9c11.6,14.2,28.7,22.4,47,22.4H263 c11,0,20-9,20-20S274,472,263,472z M161,136c0-52.9,43.1-96,96-96c52.9,0,96,43.1,96,96c0,52.2-41.8,94.8-93.7,96 c-0.7-0.1-1.5-0.1-2.3-0.1c-1.6,0-3.1,0-4.7,0.1C201.6,229.4,161,187.4,161,136z M513,412c0,11-9,20-20,20H343c-11,0-20-9-20-20 c0-11,9-20,20-20h150C504,392,513,400.9,513,412z M343,312h150c11,0,20,9,20,20s-9,20-20,20H343c-11,0-20-9-20-20S332,312,343,312z  M513,492c0,11-9,20-20,20H343c-11,0-20-9-20-20s9-20,20-20h150C504,472,513,481,513,492z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg005User);
export default __webpack_public_path__ + "static/media/005-user.209e557135758a25e78fdc8885035151.svg";
export { ForwardRef as ReactComponent };